/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RecogniserResponse } from "./RecogniserResponse";

export type TaxDocumentRequest = {
    classification?: TaxDocumentRequest.classification;
    correctorId?: string;
    currencyId?: string;
    customerCompanyIdNumber?: string;
    description?: string;
    dueDate?: string;
    issueDate?: string;
    vatApplicationDate?: string;
    kind?: TaxDocumentRequest.kind;
    ownerId?: string;
    ownerNote?: string;
    payableAmount?: number;
    paymentMeans?: TaxDocumentRequest.paymentMeans;
    preAccountingId?: string;
    processorId?: string;
    processorNote?: string;
    recogniserResponse?: RecogniserResponse;
    regNumber?: string;
    supplierCompanyIdNumber?: string;
    supplierId?: string;
    supplierPersonId?: string;
    supplierTaxIdNumber?: string;
    taxableSupplyDate?: string;
    type?: TaxDocumentRequest.type;
    vatApplicable?: boolean;
    abraDocumentTypeId?: string;
    centreId?: string;
    recogniserSupplierName?: string;
    recogniserSupplierAddress?: string;
    reverseCharge?: boolean;
    variableSymbol?: string;
    accountNumber?: string;
    bankCode?: string;
    iban?: string;
    bic?: string;
    contractId?: string;
    activityId?: string;
};

export namespace TaxDocumentRequest {
    export enum classification {
        OTHER_OBLIGATIONS = "OTHER_OBLIGATIONS",
        PRO_FORMA_INVOICE = "PRO_FORMA_INVOICE",
        INVOICE_IN_ADVANCE = "INVOICE_IN_ADVANCE",
        EXPENSE_RECEIPT = "EXPENSE_RECEIPT",
    }

    export enum kind {
        INCOMING = "INCOMING",
        OUTCOMING = "OUTCOMING",
        OTHER = "OTHER",
    }

    export enum paymentMeans {
        CASH_PAYMENT = "CASH_PAYMENT",
        CHEQUE_PAYMENT = "CHEQUE_PAYMENT",
        CREDIT_TRANSFER = "CREDIT_TRANSFER",
        MONEY_TRANSFER_TO_ACCOUNT = "MONEY_TRANSFER_TO_ACCOUNT",
        CARD_PAYMENT = "CARD_PAYMENT",
        DIRECT_DEBIT = "DIRECT_DEBIT",
        PAYMENT_BY_POSTGIRO = "PAYMENT_BY_POSTGIRO",
        COMPOSITION_BETWEEN_PARTNERS = "COMPOSITION_BETWEEN_PARTNERS",
        OTHER = "OTHER",
    }

    export enum type {
        INVOICE = "INVOICE",
        RECEIPT = "RECEIPT",
        CONFIRMATION = "CONFIRMATION",
        OTHER = "OTHER",
    }
}
